import { stringify } from 'query-string';
import * as APIRoutes from '@mm/api-routes';
import AuthenticatedController from './AuthenticatedController';
import { ObjectUtils } from '@mm/utils';
import {
  ChatStarterKindSnakeType,
  ChatStartersPayload,
} from '../model/ChatStarterModel';

const defaultPagingObj = {
  page: 1,
  perPage: 8,
};

export type ChatStartersPaginationParams = typeof defaultPagingObj;

export class ChatStartersController extends AuthenticatedController {
  // BE request for 'send_to_messenger' or 'checkbox' returns both types
  static async getAll({
    botId,
    kind,
    search,
    pagination = defaultPagingObj,
  }: {
    botId: number;
    kind: ChatStarterKindSnakeType;
    search?: string;

    pagination?: ChatStartersPaginationParams;
  }): Promise<ChatStartersPayload> {
    const queryObj = ObjectUtils.deepSnakeKeys({
      ...pagination,
      kind,
      query: search,
    });
    const query = `?${stringify(queryObj)}`;
    const path = `${APIRoutes.CHAT_STARTERS({ botId })}${query}`;
    return super.get(path);
  }
}
